import { Box, Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { CustomButton, CustomFormControl, CustomInput, Layout } from "@lubbezposrednio-frontend/commons";
import { bindProperty, bindToCommand, withModel } from "@lubbezposrednio-frontend/core";
import { ForgotPasswordViewModel } from "./ForgotPasswordViewModel";

interface ForgotPasswordViewProps {
  model: ForgotPasswordViewModel;
}

const ForgotPasswordView: React.FC<ForgotPasswordViewProps> = observer(({ model }) => {
  const toast = useToast();

  useEffect(() => {
    document.title = "Email do resetu hasła";
  }, []);

  return (
    <Layout>
      <Flex flex={1} justify="center" align="center" px="20px" py={{ base: "40px", md: "64px" }} minH="60vh">
        <Box bg="white" borderRadius="24px" border="1px solid rgba(67,0,152,0.08)" boxShadow="0 20px 50px rgba(67,0,152,0.1)" p={{ base: "32px 26px", md: "40px" }} maxW="440px" w="100%">
          <Heading fontSize={{ base: "24px", md: "27px" }} fontWeight="800" color="primary" mb="8px">
            Reset hasła
          </Heading>
          <Text color="gray.500" fontSize="15px" mb="24px">
            Podaj swój adres e-mail — wyślemy na niego link do ustawienia nowego hasła.
          </Text>

          <CustomFormControl
            isInvalid={model.isTouched && !model.isEmailCorrect}
            errorMessage="Podany adres e-mail jest niepoprawny."
            w="100%"
            labelTitle="Email"
          >
            <CustomInput autoComplete="email" {...bindProperty(model, "email")} onFocus={() => model.setIsTouched()} />
          </CustomFormControl>

          <CustomButton text="Wyślij link" {...bindToCommand(model.sendPasswordResetEmail(toast))} backgroundColor="primary" w="100%" mt="22px" />
        </Box>
      </Flex>
    </Layout>
  );
});

const ForgotPasswordViewWithModel = withModel<ForgotPasswordViewModel>(ForgotPasswordView, ForgotPasswordViewModel);

export default ForgotPasswordViewWithModel;
